import Moment from "moment";

const state = {
    liveclass_id: 0,
    statusLive: false,
    thumbnail: "",
    name: "",
    startAt: null,
    endAt: null,
    teachers: [],
    subject: "",
    liveClassRoomId: "",
};

const mutations = {
    live_class_teacher_init(state, payload) {
        state.liveclass_id = payload.liveclass_id;
        state.statusLive = payload.statusLive;
        state.thumbnail = payload.thumbnail;
        state.startAt = Moment(payload.startAt).format("DD/MM/YYYY HH:mm");
        state.endAt = Moment(payload.endAt).format("DD/MM/YYYY HH:mm");
        state.name = payload.name;
        state.teachers = payload.teachers;
        state.subject = payload.subject;
        state.liveClassRoomId = payload.liveClassRoomId;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/live_class_teacher/stores/liveclassteacher.js